// components/DeleteActionDialog.tsx

import { Button } from '@/presentation/components';
import { Dialog } from '@/presentation/components/Dialog';
import { DialogHeader } from '@/presentation/components/Dialog/DialogHeader';
import { DialogBody } from '@/presentation/components/Dialog/DialogBody';
import { DialogFooter } from '@/presentation/components/Dialog/DialogFooter';

interface DeleteActionDialogProps {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export function DeleteActionDialog({
  open,
  title,
  message,
  onClose,
  onConfirm,
}: DeleteActionDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeader>{title}</DialogHeader>

      <DialogBody>
        <p>{message}</p>
      </DialogBody>

      <DialogFooter>
        <Button
          variant="secondary"
          onClick={onClose}
        >
          Cancelar
        </Button>

        <Button onClick={onConfirm}>
          Aceptar
        </Button>
      </DialogFooter>
    </Dialog>
  );
}